import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { useTranslate } from "src/locales/use-locales";
import { initialFormData, FormDataType } from "./formMockState";

interface PreSurgeryTabProps {
  isEditable: boolean;
}
const PreSurgeryTab: React.FC<PreSurgeryTabProps> = ({ isEditable }) => {
  const { t } = useTranslate();
  const [activeTab] = useState(0);
  const [formData, setFormData] = useState<FormDataType>(initialFormData);

  // Input alanlarını güncellemek için genel handler
  const handleInputChange = (field: keyof FormDataType, value: any) => {
    setFormData({ ...formData, [field]: value });
  };

  // Radyo butonlarını güncellemek için handler
  const handleRadioChange = (field: keyof FormDataType, value: string) => {
    setFormData({ ...formData, [field]: value });
  };

  // Checkbox gruplarını güncellemek için handler
  const handleCheckboxChange = (
    group: keyof FormDataType,
    key: string,
    value: boolean
  ) => {
    const groupValue = formData[group];
    if (typeof groupValue === 'object' && groupValue !== null) {
      setFormData({
        ...formData,
        [group]: {
          ...groupValue,
          [key]: value
        }
      });
    }
  };

  return (
    <Box>
      {activeTab === 0 && (
        <Box>
          {/* Teslim Eden Bilgisi */}
          <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>
            <Box sx={{ background: "#EBF5FF", px: 2, py: 1, borderBottom: "1px solid #e0e0e0" }}>
              <strong>{t("surgery-pre-post-preparation.deliverer-info")}</strong>
            </Box>
            <Box sx={{ p: 2 }}>
              <Grid container spacing={1}>
                {/* Tarih */}
                <Grid item xs={12} md={4}>
                  <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.date")}</ByzMuiTypography>
                  <ByzMuiTextField
                    type="date"
                    fullWidth
                    size="medium"
                    value={formData.teslimTarihiPre || ""}
                    onChange={(e) => handleInputChange("teslimTarihiPre", e.target.value)}
                  />
                </Grid>

                {/* Teslim Eden */}
                <Grid item xs={12} md={4}>
                  <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.deliverer")}</ByzMuiTypography>
                  <ByzMuiTextField
                    fullWidth
                    size="medium"
                    value={formData.teslimEdenPre}
                    onChange={(e) => handleInputChange("teslimEdenPre", e.target.value)}
                  />
                </Grid>

                {/* Teslim Alan */}
                <Grid item xs={12} md={4}>
                  <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.receiver")}</ByzMuiTypography>
                  <ByzMuiTextField
                    fullWidth
                    size="medium"
                    value={formData.teslimAlanPre}
                    onChange={(e) => handleInputChange("teslimAlanPre", e.target.value)}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Form Bilgileri */}
          <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>
            <Box sx={{ background: "#EBF5FF", px: 2, py: 1, borderBottom: "1px solid #e0e0e0" }}>
              <strong>{t("surgery-pre-post-preparation.form-info")}</strong>
            </Box>
            <Box sx={{ p: 2 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                  <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.record-date")}</ByzMuiTypography>
                  <ByzMuiTextField
                    type="date"
                    fullWidth
                    size="medium"
                    value={formData.teslimTarihiPre || ""}
                    onChange={(e) => handleInputChange("teslimTarihiPre", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.recorded-by")}</ByzMuiTypography>
                  <ByzMuiTextField
                    fullWidth
                    size="medium"
                    value={formData.kayitYapanKullanici}
                    onChange={(e) => handleInputChange("kayitYapanKullanici", e.target.value)}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Hasta Bilgileri Bölümü */}
          <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>
            <Box sx={{ background: "#EBF5FF", px: 2, py: 1, borderBottom: "1px solid #e0e0e0" }}>
              <strong>{t("surgery-pre-post-preparation.patient-info")}</strong>
            </Box>
            <Box sx={{ p: 2 }}>
              <Grid container spacing={2}>
                {/* İlk Kolon (1-6) */}
                <Grid item xs={12} md={3}>
                  <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>

                    <Box sx={{ p: 2 }}>
                      {/* 1) Bölge İşaretlenmesi */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q1")}</ByzMuiTypography>

                        {/* Tarih Alanı */}
                        <ByzMuiTextField
                          type="date"
                          fullWidth
                          size="medium"
                          value={formData.bolgeIsaretlemesiTarih || ""}
                          onChange={(e) => handleInputChange("bolgeIsaretlemesiTarih", e.target.value)}
                          sx={{ mb: 2 }}
                        />

                        {/* Radyo Buton */}
                        <Grid container spacing={2} alignItems="center">

                          <Grid item xs={12} md={8}>
                            <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                              <ByzMuiRadioButton
                                typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                layout="row"
                                value={formData.bolgeIsaretlemesiYapildiMiRadio}
                                onChange={(e) => handleRadioChange("bolgeIsaretlemesiYapildiMiRadio", e.target.value)}
                              />
                            </Box>
                          </Grid>
                        </Grid>

                        {/* Checkboxlar - Her zaman görünür */}
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.bilateral")}
                              checked={formData.bolgeIsaretlemesiCheckbox.bilateral}
                              onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "bilateral", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.right")}
                              checked={formData.bolgeIsaretlemesiCheckbox.sag}
                              onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "sag", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.single-organ")}
                              checked={formData.bolgeIsaretlemesiCheckbox.tekliOrgan}
                              onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "tekliOrgan", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.left")}
                              checked={formData.bolgeIsaretlemesiCheckbox.sol}
                              onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "sol", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.level")}
                              checked={formData.bolgeIsaretlemesiCheckbox.seviye}
                              onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "seviye", e.target.checked)}
                            />
                          </Box>
                        </Box>


                        {/* Açıklama */}
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1, mt: 2 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                        <ByzMuiTextField
                          fullWidth
                          size="medium"
                          multiline
                          rows={2}
                          value={formData.bolgeIsaretlemesiAciklama}
                          onChange={(e) => handleInputChange("bolgeIsaretlemesiAciklama", e.target.value)}
                        />
                      </Box>


                      {/* 2) Allerji Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q2")}</ByzMuiTypography>

                        <Grid item xs={12} md={8}>
                          <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                            <ByzMuiRadioButton
                              typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                              layout="row"
                              value={formData.alerjisiVarMiRadio}
                              onChange={(e) => handleRadioChange("alerjisiVarMiRadio", e.target.value)}
                            />
                          </Box>

                        </Grid>
                      </Box>

                      {/* 3) Onam Formunda Hasta / Yakını İmzası Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q3")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.onamFormuImzaVarMiRadio}
                            onChange={(e) => handleRadioChange("onamFormuImzaVarMiRadio", e.target.value)}
                          />
                        </Box>
                      </Box>


                      {/* 4) Anestezi Hekiminin Değerlendirmesi Var mı? */}

                      <Box sx={{ mb: 2 }}>
                        {/* Soru başlığı */}
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>
                          {t("surgery-pre-post-preparation.q4")}
                        </ByzMuiTypography>

                        {/* Radiobuttonlar */}
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.anesteziHekimiDegerlendirmesiRadio}
                            onChange={(e) => handleRadioChange("anesteziHekimiDegerlendirmesiRadio", e.target.value)}
                          />
                        </Box>

                        {/* Checkboxlar - sağa kaydırılarak hizalanmış */}
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.local-anesthesia")}
                              checked={formData.anesteziHekimiDegerlendirmesiCheckbox.lokalAnesteziYapilacak}
                              onChange={(e) =>
                                handleCheckboxChange("anesteziHekimiDegerlendirmesiCheckbox", "lokalAnesteziYapilacak", e.target.checked)
                              }
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.other")}
                              checked={formData.anesteziHekimiDegerlendirmesiCheckbox.diger}
                              onChange={(e) =>
                                handleCheckboxChange("anesteziHekimiDegerlendirmesiCheckbox", "diger", e.target.checked)
                              }
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.pre-done")}
                              checked={formData.anesteziHekimiDegerlendirmesiCheckbox.oncedenYapilmis}
                              onChange={(e) =>
                                handleCheckboxChange("anesteziHekimiDegerlendirmesiCheckbox", "oncedenYapilmis", e.target.checked)
                              }
                            />
                          </Box>
                        </Box>

                        {/* Açıklama alanı */}
                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>
                            {t("surgery-pre-post-preparation.desc")}
                          </ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.anesteziHekimiDegerlendirmesiAciklama}
                            onChange={(e) => handleInputChange("anesteziHekimiDegerlendirmesiAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>



                      {/* 5) Laboratuvar Tetkikleri Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q5")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.laboratuvarTetkikleriVarMiRadio}
                            onChange={(e) => handleRadioChange("laboratuvarTetkikleriVarMiRadio", e.target.value)}
                          />

                        </Box>
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.pre-done")}
                              checked={formData.laboratuvarTetkikleriOncedenYapilmis}
                              onChange={(e) => handleInputChange("laboratuvarTetkikleriOncedenYapilmis", e.target.checked)}
                            />
                          </Box>
                        </Box>
                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.laboratuvarTetkikleriAciklama}
                            onChange={(e) => handleInputChange("laboratuvarTetkikleriAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>

                      {/* 6) Radyoloji Tetkikleri Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q6")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.radyolojiTetkikleriVarMiRadio}
                            onChange={(e) => handleRadioChange("radyolojiTetkikleriVarMiRadio", e.target.value)}
                          />
                        </Box>
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.lung-x-ray")}
                              checked={formData.radyolojiTetkikleriCheckbox.akcigerGrafisi}
                              onChange={(e) =>
                                handleCheckboxChange("radyolojiTetkikleriCheckbox", "akcigerGrafisi", e.target.checked)
                              }
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.other")}
                              checked={formData.radyolojiTetkikleriCheckbox.diger}
                              onChange={(e) =>
                                handleCheckboxChange("radyolojiTetkikleriCheckbox", "diger", e.target.checked)
                              }
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.pre-done")}
                              checked={formData.radyolojiTetkikleriCheckbox.oncedenYapilmis}
                              onChange={(e) =>
                                handleCheckboxChange("radyolojiTetkikleriCheckbox", "oncedenYapilmis", e.target.checked)
                              }
                            />
                          </Box>
                        </Box>

                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.radyolojiTetkikleriAciklama}
                            onChange={(e) => handleInputChange("radyolojiTetkikleriAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>

                    </Box>
                  </Box>
                </Grid>

                {/* İkinci Kolon (7-12) */}
                <Grid item xs={12} md={3}>
                  <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>

                    <Box sx={{ p: 2 }}>
                      {/* 7) Kurum Dışından Getirdiği Tetkikler Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q7")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.kurumDisiTetkiklerVarMiRadio}
                            onChange={(e) => handleRadioChange("kurumDisiTetkiklerVarMiRadio", e.target.value)}
                          />
                        </Box>
                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.kurumDisiTetkiklerAciklama}
                            onChange={(e) => handleInputChange("kurumDisiTetkiklerAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>

                      {/* 8) Bulaşıcı Hastalığı Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q8")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.bulasiciHastaligiVarMiRadio}
                            onChange={(e) => handleRadioChange("bulasiciHastaligiVarMiRadio", e.target.value)}
                          />
                        </Box>
                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.bulasiciHastaligiAciklama}
                            onChange={(e) => handleInputChange("bulasiciHastaligiAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>

                      {/* 9) Hasta Aç mı? */}
                      <Box sx={{ mb: 2 }}>
                        {/* Soru Başlığı */}
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>
                          {t("surgery-pre-post-preparation.q9")}
                        </ByzMuiTypography>

                        {/* Radio Buttonlar */}
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.hastaAcMiRadio}
                            onChange={(e) => handleRadioChange("hastaAcMiRadio", e.target.value)}
                          />
                        </Box>

                        {/* Checkboxlar - Aynı hizada */}
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.patient-ate")}
                              checked={formData.hastaAcMiCheckbox.hastaYemis}
                              onChange={(e) => handleCheckboxChange("hastaAcMiCheckbox", "hastaYemis", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.other")}
                              checked={formData.hastaAcMiCheckbox.diger}
                              onChange={(e) => handleCheckboxChange("hastaAcMiCheckbox", "diger", e.target.checked)}
                            />
                          </Box>
                        </Box>

                        {/* Açıklama Alanı */}
                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}
                          </ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.hastaAcMiAciklama}
                            onChange={(e) => handleInputChange("hastaAcMiAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>


                      {/* 10) Ameliyat Bölgesi Traşı Yapıldı mı? */}
                      <Box sx={{ mb: 2 }}>
                        {/* Soru başlığı */}
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>
                          {t("surgery-pre-post-preparation.q10")}
                        </ByzMuiTypography>

                        {/* Radiobuttonlar */}
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.ameliyatBolgesiTrasiYapildiMiRadio}
                            onChange={(e) => handleRadioChange("ameliyatBolgesiTrasiYapildiMiRadio", e.target.value)}
                          />
                        </Box>

                        {/* Checkboxlar - sağa kaydırılarak hizalanmış */}
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.patient-refused")}
                              checked={formData.ameliyatBolgesiTrasiCheckbox.hastaIstemedi}
                              onChange={(e) => handleCheckboxChange("ameliyatBolgesiTrasiCheckbox", "hastaIstemedi", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.surgical-site-clean")}
                              checked={formData.ameliyatBolgesiTrasiCheckbox.ameliyatBolgesiTemiz}
                              onChange={(e) => handleCheckboxChange("ameliyatBolgesiTrasiCheckbox", "ameliyatBolgesiTemiz", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.in-operating-room")}
                              checked={formData.ameliyatBolgesiTrasiCheckbox.ameliyathanedeYapilacak}
                              onChange={(e) => handleCheckboxChange("ameliyatBolgesiTrasiCheckbox", "ameliyathanedeYapilacak", e.target.checked)}
                            />
                          </Box>
                        </Box>

                        {/* Açıklama alanı */}
                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>
                            {t("surgery-pre-post-preparation.desc")}
                          </ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.anesteziHekimiDegerlendirmesiAciklama}
                            onChange={(e) => handleInputChange("anesteziHekimiDegerlendirmesiAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>



                      {/* 11) Konsültasyon Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q11")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.konsultasyonVarMiRadio}
                            onChange={(e) => handleRadioChange("konsultasyonVarMiRadio", e.target.value)}
                          />
                        </Box>

                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.if-yes")}
                              checked={formData.konsultasyonEvetIseCheckbox}
                              onChange={(e) => handleInputChange("konsultasyonEvetIseCheckbox", e.target.checked)}
                            />
                          </Box>
                        </Box>
                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.konsultasyonAciklama}
                            onChange={(e) => handleInputChange("konsultasyonAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>



                      {/* 12) Ameliyat Öncesi Uygulanan İşlemler Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q12")}</ByzMuiTypography>

                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.ameliyatOncesiUygulananIslemlerVarMiRadio}
                            onChange={(e) => handleRadioChange("ameliyatOncesiUygulananIslemlerVarMiRadio", e.target.value)}
                          />
                        </Box>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                        <ByzMuiTextField
                          fullWidth
                          size="medium"
                          multiline
                          rows={2}
                          value={formData.ameliyatOncesiUygulananIslemlerAciklama}
                          onChange={(e) => handleInputChange("ameliyatOncesiUygulananIslemlerAciklama", e.target.value)}
                        />
                        {/* Sonra checkboxlar */}
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.enema")}
                              checked={formData.ameliyatOncesiUygulananIslemlerCheckbox.lavman}
                              onChange={(e) => handleCheckboxChange("ameliyatOncesiUygulananIslemlerCheckbox", "lavman", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.varicose-veins-socks")}
                              checked={formData.ameliyatOncesiUygulananIslemlerCheckbox.varisCorabi}
                              onChange={(e) => handleCheckboxChange("ameliyatOncesiUygulananIslemlerCheckbox", "varisCorabi", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.iv-catheter")}
                              checked={formData.ameliyatOncesiUygulananIslemlerCheckbox.ivKateteri}
                              onChange={(e) => handleCheckboxChange("ameliyatOncesiUygulananIslemlerCheckbox", "ivKateteri", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.urinary-catheter")}
                              checked={formData.ameliyatOncesiUygulananIslemlerCheckbox.idrarKateteri}
                              onChange={(e) => handleCheckboxChange("ameliyatOncesiUygulananIslemlerCheckbox", "idrarKateteri", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.ng")}
                              checked={formData.ameliyatOncesiUygulananIslemlerCheckbox.ng}
                              onChange={(e) => handleCheckboxChange("ameliyatOncesiUygulananIslemlerCheckbox", "ng", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.body-bath")}
                              checked={formData.ameliyatOncesiUygulananIslemlerCheckbox.vucutBanyosu}
                              onChange={(e) => handleCheckboxChange("ameliyatOncesiUygulananIslemlerCheckbox", "vucutBanyosu", e.target.checked)}
                            />
                          </Box>
                        </Box>
                      </Box>

                    </Box>
                  </Box>
                </Grid>

                {/* Üçüncü Kolon (13-18) */}
                <Grid item xs={12} md={3}>
                  <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>
                    <Box sx={{ p: 2 }}>
                      {/* 13) Makyaj ve Oje Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q13")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.makyajVeOjeVarMiRadio}
                            onChange={(e) => handleRadioChange("makyajVeOjeVarMiRadio", e.target.value)}
                          />
                        </Box>
                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.kurumDisiTetkiklerAciklama}
                            onChange={(e) => handleInputChange("kurumDisiTetkiklerAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>

                      {/* 14) Hasta Kol Bandı Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q14")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.hastaKolBandiVarMiRadio}
                            onChange={(e) => handleRadioChange("hastaKolBandiVarMiRadio", e.target.value)}
                          />
                        </Box>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                        <ByzMuiTextField
                          fullWidth
                          size="medium"
                          multiline
                          rows={2}
                          value={formData.hastaKolBandiAciklama}
                          onChange={(e) => handleInputChange("hastaKolBandiAciklama", e.target.value)}
                        />
                      </Box>
                      {/* 15) Protez veya Değerli Eşya Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>
                          {t("surgery-pre-post-preparation.q15")}
                        </ByzMuiTypography>

                        {/* Radiobuttonlar */}
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.protezVeyaDegerliEsyaVarMiRadio}
                            onChange={(e) => handleRadioChange("protezVeyaDegerliEsyaVarMiRadio", e.target.value)}
                          />
                        </Box>

                        {/* Checkboxlar */}
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.removed")}
                              checked={formData.protezVeyaDegerliEsyaCheckbox.cikarildi}
                              onChange={(e) => handleCheckboxChange("protezVeyaDegerliEsyaCheckbox", "cikarildi", e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.not-removed")}
                              checked={formData.protezVeyaDegerliEsyaCheckbox.cikarilmadi}
                              onChange={(e) => handleCheckboxChange("protezVeyaDegerliEsyaCheckbox", "cikarilmadi", e.target.checked)}
                            />
                          </Box>
                        </Box>

                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                        <ByzMuiTextField
                          fullWidth
                          size="medium"
                          multiline
                          rows={2}
                          value={formData.protezVeyaDegerliEsyaAciklama}
                          onChange={(e) => handleInputChange("protezVeyaDegerliEsyaAciklama", e.target.value)}
                        />
                      </Box>


                      {/* 16) Piercing Var mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q16")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.piercingVarMiRadio}
                            onChange={(e) => handleRadioChange("piercingVarMiRadio", e.target.value)}
                          />
                        </Box>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                        <ByzMuiTextField
                          fullWidth
                          size="medium"
                          multiline
                          rows={2}
                          value={formData.piercingVarMiAciklama}
                          onChange={(e) => handleInputChange("piercingVarMiAciklama", e.target.value)}
                        />
                      </Box>

                      {/* 17) Mesane Boşaltıldı mı? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q17")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.mesaneBosaltildiMiRadio}
                            onChange={(e) => handleRadioChange("mesaneBosaltildiMiRadio", e.target.value)}
                          />
                        </Box>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                        <ByzMuiTextField
                          fullWidth
                          size="medium"
                          multiline
                          rows={2}
                          value={formData.mesaneBosaltildiMiAciklama}
                          onChange={(e) => handleInputChange("mesaneBosaltildiMiAciklama", e.target.value)}
                        />
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.probe")}
                              checked={formData.ameliyatSirasiKanUrunleriVarMiCheckbox.varIse}
                              onChange={(e) => handleCheckboxChange('ameliyatSirasiKanUrunleriVarMiCheckbox', 'varIse', e.target.checked)}
                            />
                          </Box>
                        </Box>

                        {/* 18) Hastanın Tüm Çamaşırları Çıkarıldı mı? */}
                        <Box>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q18")}</ByzMuiTypography>
                          <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                            <ByzMuiRadioButton
                              typographyText={`${t("surgery-pre-post-preparation.form.removed")},${t("surgery-pre-post-preparation.form.patient-refused")},${t("surgery-pre-post-preparation.form.unknown")}`}
                              layout="row"
                              value={formData.hastaTumCamAsirlariCikarildiMiRadio}
                              onChange={(e) => handleRadioChange("hastaTumCamAsirlariCikarildiMiRadio", e.target.value)}
                            />
                          </Box>

                        </Box>
                      </Box>
                    </Box>
                  </Box>

                </Grid>

                {/* Dördüncü Kolon (19-23) */}
                <Grid item xs={12} md={3}>
                  <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>
                    <Box sx={{ p: 2 }}>
                      {/* 19) Hasta Önlüğü/Bone Verildi mi? */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q19")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.gowned")},${t("surgery-pre-post-preparation.form.patient-refused")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.hastaOnluguVeBonesiGiyiliMiRadio}
                            onChange={(e) => handleRadioChange('hastaOnluguVeBonesiGiyiliMiRadio', e.target.value)}
                          />
                        </Box>
                      </Box>

                      {/* 20) Hasta Sedye Kenarları */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q20")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.raised")},${t("surgery-pre-post-preparation.form.not-raised")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.hastaSedyeKemerleriBagliMiRadio}
                            onChange={(e) => handleRadioChange('hastaSedyeKemerleriBagliMiRadio', e.target.value)}
                          />
                        </Box>

                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.patient-refused")}
                              checked={formData.premedikasyonUygulamalariCheckbox.hastaIstemedi}
                              onChange={(e) => handleCheckboxChange('premedikasyonUygulamalariCheckbox', 'hastaIstemedi', e.target.checked)}
                            />
                          </Box>
                        </Box>
                        <Box mt={1}>
                          <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                          <ByzMuiTextField
                            fullWidth
                            size="medium"
                            multiline
                            rows={2}
                            value={formData.konsultasyonAciklama}
                            onChange={(e) => handleInputChange("konsultasyonAciklama", e.target.value)}
                          />
                        </Box>
                      </Box>

                      {/* 21) İlaç Uygulamaları Var mı? */}
                      <Box>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q21")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.ilacUygulamalariVarMiRadio}
                            onChange={(e) => handleRadioChange('ilacUygulamalariVarMiRadio', e.target.value)}
                          />
                        </Box>

                      </Box>

                      {/* 22) Premedikasyon Uygulamaları */}
                      <Box sx={{ mb: 2 }}>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q22")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.premedikasyonUygulamalariYapildiMiRadio}
                            onChange={(e) => handleRadioChange('premedikasyonUygulamalariYapildiMiRadio', e.target.value)}
                          />
                        </Box>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                        <ByzMuiTextField
                          fullWidth
                          size="medium"
                          multiline
                          rows={2}
                          value={formData.premedikasyonUygulamalariAciklama}
                          onChange={(e) => handleInputChange('premedikasyonUygulamalariAciklama', e.target.value)}
                        />

                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.patient-refused")}
                              checked={formData.premedikasyonUygulamalariCheckbox.hastaIstemedi}
                              onChange={(e) => handleCheckboxChange('premedikasyonUygulamalariCheckbox', 'hastaIstemedi', e.target.checked)}
                            />
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.local-anesthesia-checkbox")}
                              checked={formData.premedikasyonUygulamalariCheckbox.lokalAnestezi}
                              onChange={(e) => handleCheckboxChange('premedikasyonUygulamalariCheckbox', 'lokalAnestezi', e.target.checked)}
                            />
                          </Box>
                        </Box>
                      </Box>

                      {/* 23) Ameliyat Sırasında Kullanılmak İçin Hazırlanmış Kan ve Kan Ürünleri Var mı? */}
                      <Box>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q23")}</ByzMuiTypography>
                        <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                          <ByzMuiRadioButton
                            typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                            layout="row"
                            value={formData.ameliyatSirasiKanUrunleriVarMiRadio}
                            onChange={(e) => handleRadioChange('ameliyatSirasiKanUrunleriVarMiRadio', e.target.value)}
                          />
                        </Box>
                        <Box sx={{ pl: "22px", mt: 1 }}>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <ByzMuiCheckBox
                              text={t("surgery-pre-post-preparation.form.if-any")}
                              checked={formData.ameliyatSirasiKanUrunleriVarMiCheckbox.varIse}
                              onChange={(e) => handleCheckboxChange('ameliyatSirasiKanUrunleriVarMiCheckbox', 'varIse', e.target.checked)}
                            />
                          </Box>
                        </Box>
                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                        <ByzMuiTextField
                          fullWidth
                          size="medium"
                          multiline
                          rows={2}
                          value={formData.ameliyatSirasiKanUrunleriVarMiAciklama}
                          onChange={(e) => handleInputChange('ameliyatSirasiKanUrunleriVarMiAciklama', e.target.value)}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      )
      }
    </Box >
  );
};

export default PreSurgeryTab;